<div class="flex flex-col tk-bg-gray-5 h-screen">

  <div class="bg-white">
    <div class="mt-4 ml-7 font-semibold text-xl">{{'data-sharing.data-sharing-label' | translate}}</div>
  </div>

  <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms" class="grow h-full ">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black text-xs">
          {{'data-sharing.link-with-vehicles' | translate}}
        </div>
      </ng-template>
      <dsm-links-list class="h-full"></dsm-links-list>
<!--      <router-outlet></router-outlet>-->
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black text-xs">
          {{'data-sharing.for-external-systems' | translate}}
        </div>
      </ng-template>
      <div class="flex flex-col h-full ">
        <dsm-integrations class="h-full" (onEmptyStateSubmit$)="goToIntegrationsTab()"></dsm-integrations>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black text-xs">
          {{'API TEKOM' | translate}}
        </div>
      </ng-template>
      <div class="flex flex-col h-full">
        <app-api-tekom-form-view class="h-full"/>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
